import React from 'react'
import { useIntl } from 'react-intl'
import { TextInput } from '../../../legacy-design-system/form-text'
import { ContrastFormattedMessage } from '../../contrast-formatted-message'
import { GetFormFieldPropsFn } from '../../../legacy-design-system/form/form-validator'

export const isValidLogPath = (logPath?: string) => {
  if (!logPath || logPath.trim().length === 0) {
    return true
  }

  const fileFormat = logPath.slice(-4)

  return fileFormat === '.txt' || fileFormat === '.log'
}

export function LogPathInput({
  value,
  onChange,
  getFormFieldProps,
  isReadOnly
}: {
  value: string | undefined
  onChange: (value: string) => void
  getFormFieldProps: GetFormFieldPropsFn
  isReadOnly?: boolean
}) {
  const { formatMessage } = useIntl()

  return (
    <ContrastFormattedMessage id="title_servers_serverLogFile">
      {(labelLogFile) => (
        <TextInput
          data-testid="log-path-input"
          label={labelLogFile}
          value={value || ''}
          onChange={onChange}
          placeholder="/path/to/contrast.log"
          disabled={isReadOnly}
          {...getFormFieldProps({
            id: 'logPath',
            validator: ({ validity }) => {
              if (!isValidLogPath(value)) {
                return false
              }

              return validity.valid
            },
            getErrorMessage: () => {
              return formatMessage({
                id: 'validation_correctLogPathFormat'
              })
            }
          })}
        />
      )}
    </ContrastFormattedMessage>
  )
}
